import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const {
  BASE_FONT_FAMILY,
  LOGIN_TEXT_COLOR,
  LOGIN_FORM_BG_COLOR,
  LOGIN_HIGHLIGHT_COLOR,
  LOGIN_INPUT_COLOR,
  DANGER_STATUS_COLOR,
  WHITE
} = constants;

let styles = {
  base: {
    fontSize: '1.1em',
    color: LOGIN_TEXT_COLOR,
    fontFamily: BASE_FONT_FAMILY,
    height: 47,
    width: '100%',
    border: `1px solid ${LOGIN_HIGHLIGHT_COLOR}`,
    borderRadius: 5,
    backgroundColor: LOGIN_FORM_BG_COLOR,
    margin: 10,
    padding: '10px 27px',
    boxSizing: 'border-box',
    '::placeholder': {
      color: LOGIN_INPUT_COLOR
    }
  },
  error: {
    alignSelf: 'flex-start',
    fontSize: '0.9em',
    fontWeight: 500,
    marginTop: 5,
    color: DANGER_STATUS_COLOR
  },
  checkbase: {
    display: 'inline-block',
    position: 'relative',
    cursor: 'pointer',
    userSelect: 'none',
    margin: '2px 0',
    ':hover input ~ span': {
      borderColor: '#bbb'
    }
  },
  checkWrap: {
    display: 'flex',
    alignItems: 'center',
    // paddingLeft: '5px',
    alignSelf: 'flex-start',
  },
  label: {
    display: 'inline-block',
    color: WHITE,
    cursor: 'pointer',
    userSelect: 'none'
  },
  icon:{
    color: WHITE,
    fontSize: '1.4em',
    marginRight: 10
  },
  checkinput: {
    position: 'absolute',
    opacity: 0,
    cursor: 'pointer'
  }
};

export default StyleSheet.create(styles);


// WEBPACK FOOTER //
// ./src/components/inputs/password/PasswordInput.styles.js